import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type * as Types from '../../codegen/types.js';

const defaultOptions = {} as const;
export type AdvancedPaymentMethodsQueryVariables = Types.Exact<{
  input: Types.AdvancedPaymentMethodsInput;
}>;

export type AdvancedPaymentMethodsQuery = {
  __typename?: 'Query';
  advancedPaymentMethods: {
    __typename?: 'AdvancedPaymentMethodsResponse';
    paymentMethods?: Array<{
      __typename?: 'PaymentMethods';
      name: string;
      type: string;
      brands?: Array<string> | null;
      configuration?: {
        __typename?: 'PaymentMethodConfiguration';
        merchantId?: string | null;
        gatewayMerchantId?: string | null;
      } | null;
    } | null> | null;
  };
};

export const AdvancedPaymentMethodsDocument = gql`
  query advancedPaymentMethods($input: AdvancedPaymentMethodsInput!) {
    advancedPaymentMethods(input: $input) {
      paymentMethods {
        name
        type
        brands
        configuration {
          merchantId
          gatewayMerchantId
        }
      }
    }
  }
`;

/**
 * __useAdvancedPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useAdvancedPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedPaymentMethodsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdvancedPaymentMethodsQuery(
  baseOptions: Apollo.QueryHookOptions<AdvancedPaymentMethodsQuery, AdvancedPaymentMethodsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdvancedPaymentMethodsQuery, AdvancedPaymentMethodsQueryVariables>(
    AdvancedPaymentMethodsDocument,
    options,
  );
}
export function useAdvancedPaymentMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdvancedPaymentMethodsQuery, AdvancedPaymentMethodsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdvancedPaymentMethodsQuery, AdvancedPaymentMethodsQueryVariables>(
    AdvancedPaymentMethodsDocument,
    options,
  );
}
export type AdvancedPaymentMethodsQueryHookResult = ReturnType<typeof useAdvancedPaymentMethodsQuery>;
export type AdvancedPaymentMethodsLazyQueryHookResult = ReturnType<typeof useAdvancedPaymentMethodsLazyQuery>;
export type AdvancedPaymentMethodsQueryResult = Apollo.QueryResult<
  AdvancedPaymentMethodsQuery,
  AdvancedPaymentMethodsQueryVariables
>;
